export const BAY_TYPE_RESERVED = 'Reserved'
export const BAY_TYPE_UNRESERVED = 'Unreserved'
export const BAY_TYPE_ACCESS = 'Access'
export const START_DATE_MUST_BE_BEFORE_END_DATE = 'End time can not be before start time'
export const START_DATE_MUST_BE_TODAY_OR_FUTURE_DATE = 'Start Date must be Today or Future Date'
export const USER_ALREADY_ASSIGN_IN_THAT_TIME = 'User already assigned in that time'
export const USER_SELECTED_TIME_OVERLAP = 'selected time is overlapping please try another time'
